import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { ErrorPage } from './ErrorPage';

const SomethingWentWrongPage: React.FC<WithTranslation> = ({ t }) => {
  const title = t('something-went-wrong-title');
  const blurb = t('something-went-wrong-blurb');

  return (
    <ErrorPage
      title={title}
      blurb={blurb}
    />
  );
};

const TranslatedComponent = withTranslation()(SomethingWentWrongPage);

export { TranslatedComponent as SomethingWentWrongPage };
